import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import EventContent from "./EventContent";
import { eventService } from '../../service/firebase/eventService';
import type { Event } from '../../type';

const EventPage = () => {
  const queryClient = useQueryClient();

  // 이벤트 목록 조회
  const { data: events = [], isLoading, error } = useQuery({
    queryKey: ['events'],
    queryFn: () => eventService.getAllEvents(),
  });

  // 이벤트 추가
  const addEventMutation = useMutation({
    mutationFn: (event: Event) => eventService.createEvent(event),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['events'] });
    },
  });

  // 이벤트 수정
  const updateEventMutation = useMutation({
    mutationFn: (event: Event) => eventService.updateEvent(event.eventId, event),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['events'] });
    },
  });

  // 이벤트 삭제
  const deleteEventMutation = useMutation({
    mutationFn: (eventId: string) => eventService.deleteEvent(eventId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['events'] });
    },
  });

  const handleAddEvent = async (event: Event) => {
    await addEventMutation.mutateAsync(event);
  };

  const handleUpdateEvent = async (event: Event) => {
    await updateEventMutation.mutateAsync(event);
  };

  const handleDeleteEvent = async (eventId: string) => {
    await deleteEventMutation.mutateAsync(eventId);
  };

  return (
    <EventContent 
      events={events}
      loading={isLoading}
      error={error?.message || null}
      addEvent={handleAddEvent}
      updateEvent={handleUpdateEvent}
      deleteEvent={handleDeleteEvent}
    />
  );
};

export default EventPage;